module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/administrative/joanna-rodak-7581afead6d56a6fe0848acb8150ae26.webp";